



























































































































































































































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import { RecurrenceRule, RecurenceConfig } from "@/shared/Recurrence";
import VueCronEditorBuefy from "vue-cron-editor-buefy";
import RapportSelection from "@/components/rapportSelection.vue";
import RapportConfig from "@/components/rapportConfig.vue";
import RapportMixin from "@/mixins/rapportMixin";
import ErrorMixin from "@/mixins/errorMixins";
import { Rapport } from "@/shared/Rapport";
import DateChooser from "@/components/dateChooser.vue";
import DateType from "@/shared/DateType";
import { watch } from "fs";

@Component({
  name: "RuleAdder",
  components: {
    VueCronEditorBuefy,
    RapportConfig,
    RapportSelection,
    DateChooser,
  },
})
export default class RuleAdder extends mixins(ErrorMixin, RapportMixin) {
  @Prop() public selectedRule!: RecurrenceRule;
  @Prop() public configRules!: { [key: string]: any };

  public dateType = new DateType();
  public listVidages = new Array();
  public selectedRegleConfig: RecurenceConfig[] = new Array();
  public dialogRapport = false;
  public dialogSupprRule = false;
  public msgErreurChampVide = this.$t("msgErreurChampVide").toString();
  public chooseReport = false;
  public chooseReportKey = 0;
  public rapport: Rapport = new Rapport();

  /*
   * variable permettant de traduire les différents textes du cron
   */
  public customLabel = {
    fr: {
      every: "Tous les",
      daysAt: "jour(s) à",
      at: "à",
      onThe: "Le",
      dayOfEvery: "jour, de chaque",
      monthsAt: "mois, à",
      everyDay: "Tous les",
      mon: "Lun",
      tue: "Mar",
      wed: "Mer",
      thu: "Jeu",
      fri: "Ven",
      sat: "Sam",
      sun: "Dim",
      daily: "QUOTIDIEN",
      weekly: "HEBDOMADAIRE",
      monthly: "MENSUEL",
    },
  };

  public listPeriodes = [
    { id: "J", title: "Aujourd'hui", p: 0 },
    { id: "J_PRECEDENT", title: "Hier", p: 0 },
    { id: "AVANT_HIER", title: "AvantHier", p: 0 },
    { id: "LUN_A_DIM", title: "SemaineEnCours", p: 1 },
    { id: "SEMAINE_PRECEDENTE", title: "SemainePrecedente", p: 1 },
    { id: "MOIS", title: "MoisEnCours", p: 2 },
    { id: "MOIS_PRECEDENT", title: "MoisPrecedent", p: 2 },
    { id: "SIX_DERNIERS_MOIS", title: "SIX_DERNIERS_MOIS", p: 2 },
    { id: "ANNEE", title: "AnneeEnCours", p: 3 },
    { id: "ANNEE_PRECEDENTE", title: "AnneePrecedente", p: 3 },
    { id: "MOINS_365", title: "MOINS_365", p: 3 },
  ];

  public mounted() {
    this.selectedRegleConfig = this.configRules.FabricExportableRapportGeneral;
  }

  public updateRapport(rapport: Rapport) {
    this.rapport = rapport;

    if (this.rapport.lSites.length === 0) {
      this.rapport.lSites.push(this.sites[0]);
    }
    this.ruleToEdit.$decodedScript = {};
    this.ruleToEdit.$decodedScript.rapportClassName =
      rapport.typeRapport.className;
    this.ruleToEdit.$decodedScript.formatExports = [rapport.format];
    this.ruleToEdit.$decodedScript.periode = rapport.typePeriode;
    this.ruleToEdit.$decodedScript.sites = rapport.lSites.map(
      (site: any) => site.restaurantId
    );
    this.ruleToEdit.$decodedScript.tpv = [];
    this.ruleToEdit.$decodedScript.idUtilisateur = this.me.id;
  }

  @Watch("selectedRule", { immediate: true })
  public onPropertyChanged(value: RecurrenceRule, oldValue: RecurrenceRule) {
    if (!value || !this.configRules || !this.ruleToEdit) {
        return;
    }

    this.selectedRegleConfig = this.configRules["FabricExportableRapportGeneral"];
    if (this.ruleToEdit.id === undefined || this.ruleToEdit.id === "") {
        this.makeMeNew();
        this.ruleToEdit.fabricExportableClassName = "FabricExportableRapportGeneral";
    } else {
        if (!this.ruleToEdit.script) {
            return;
        }
        try {
            this.ruleToEdit.$decodedScript = JSON.parse(this.ruleToEdit.script);
            this.setRapportFromSelectedRule();
            if (this.ruleToEdit.$decodedScript.rapportClassName) {
                this.rapport.typeRapport.className = this.ruleToEdit.$decodedScript.rapportClassName;
            }
            if (this.ruleToEdit.$decodedScript.formatExports && this.ruleToEdit.$decodedScript.formatExports.length > 0) {
                this.rapport.format = this.ruleToEdit.$decodedScript.formatExports[0];
            }
            this.$nextTick(() => {
              if (this.ruleToEdit.$decodedScript.periode &&
                  (!this.rapport.typePeriode || this.rapport.typePeriode === "")) {
                  this.rapport.typePeriode = this.ruleToEdit.$decodedScript.periode;
              }
            });
        } catch (error) {
            console.error("Erreur lors du parsing du script:", error);
        }
    }
  }

  public setRapportFromSelectedRule() {
    if (!this.ruleToEdit ||
        !this.ruleToEdit.$decodedScript ||
        !this.ruleToEdit.$decodedScript.sites ||
        !Array.isArray(this.ruleToEdit.$decodedScript.sites)) {
        console.log("Sites non disponibles dans $decodedScript");
        this.rapport.lSites = [];
        return;
    }
    if (!this.sites || !Array.isArray(this.sites)) {
        console.log("Liste des sites non disponible");
        this.rapport.lSites = [];
        return;
    }
    this.rapport.lSites = this.sites.filter((site) =>
        this.ruleToEdit.$decodedScript.sites.includes(site.restaurantId)
    );
    const periodeId = this.listPeriodes.find(
        (p) => p.id === this.ruleToEdit.$decodedScript.periode
    );
    this.rapport.periode = periodeId ? periodeId.p : 0;
  }

  public openConfigVue() {
    this.chooseReportKey++;
    this.chooseReport = true;
  }

  public closeConfigVue() {
    this.chooseReport = false;
  }

  public updateCron(event: any) {
    this.ruleToEdit.cron = event;
  }

  public updateDate(event: any) {
    const periode = event.typePeriode;
    this.ruleToEdit.$decodedScript["periode"] = periode;
  }

  public getReportName(className: string) {
    return this.getReportbyClassName(className);
  }

  /*
    Méthode permettant de supprimer une règle
    */
  public async deleteRule() {
    this.$emit("deleteRule", this.ruleToEdit);
    this.dialogSupprRule = false;
  }

  /**
   * methode d'enregistrement de la regle
   */
  public saveRule() {
    if (this.ruleToEdit.name === "") {
      const err =
        this.$t("Nom").toString() + " " + this.$t("required").toString();
      this.setErrorFromTxt(err);
      return;
    }
    if (this.ruleToEdit.cron === "" || !this.ruleToEdit.cron) {
      const err = "Cron " + this.$t("required").toString();
      this.setErrorFromTxt(err);
      return;
    }

    this.ruleToEdit.script = JSON.stringify(this.ruleToEdit.$decodedScript);
    if (this.ruleToEdit.id !== "") {
      this.updateRule();
    } else {
      this.addRule();
    }
  }

  /*
    Méthode permettant d'ajouter une nouvelle règle
    */
  private async addRule() {
    this.$emit("addRule", this.ruleToEdit);
  }

  /*
    Méthode permettant de modifier une règle
    */
  private async updateRule() {
    this.$emit("updateRule", this.ruleToEdit);
  }

  private makeMeNew() {
    this.selectedRegleConfig.map((rule: any) => {
      switch (rule.typeChamp) {
        case "java.lang.Class":
        case "java.util.UUID":
        case "eu.cashsystemes.starmanager.Periode":
          this.ruleToEdit.$decodedScript[rule.nomChamp] = "";
          break;
        case "java.util.Collection":
          this.ruleToEdit.$decodedScript[rule.nomChamp] = new Array();
          break;
      }
    });
  }

  get ruleToEdit(): RecurrenceRule {
    return this.selectedRule;
  }

  set ruleToEdit(rule: RecurrenceRule) {
    // emit
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
}
